import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrNotCompletedGet, SrReportService } from '@app/services/sr-report.service';

@Component({
    selector: 'tt-sr-not-completed',
    templateUrl: './sr-not-completed.component.html',
    styleUrls: ['./sr-not-completed.component.css'],
    standalone: false,
})
export class SrNotCompletedComponent implements OnInit {
    public page?: SrNotCompletedGet;
    public reports: Item[] = [];
    public error = '';
    constructor(private readonly report: SrReportService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }
    public async ngOnInit(): Promise<void> {
        try {
            this.page = await this.report.getIncompleteReports({ resource_id: String(this.navigator?.params['resource_id'] ?? '') });
            if (!this.page.resource_id?.trim()) return;
            this.reports = [];
            this.reports = await this.report.getIncompleteReportList({ resource_id: this.page.resource_id });
        } catch (error) { this.error = error instanceof Error ? error.message : String(error); }
    }
    public newReport(): void {
        if (this.page) this.navigator?.go({ to: 'srnotcompletednew-test', parms: { resource_id: this.page.resource_id } });
    }
    public openItem(event: { item: Item; event: MouseEvent }): void {
        if (!event.item.item_state) return;
        const to = ['srnotcompleted', 'srnotcompletednew'].includes(event.item.item_state) ? `${event.item.item_state}-test` : event.item.item_state;
        const target = { to, parms: event.item.item_parms };
        if (event.event.ctrlKey) this.navigator?.newTab(target); else this.navigator?.go(target);
    }
}
